import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { IRiskLevelDescription } from '@interfaces/lookups';
import { handleGetRiskLevelDescriptions } from '@store/features/riskLevelDescriptions/actions';
import {
  riskLevelDescriptionsErrorSelector,
  riskLevelDescriptionsIsLoadingSelector,
  riskLevelDescriptionsIsReadySelector,
  riskLevelDescriptionsSelector,
} from '@store/features/riskLevelDescriptions/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useRiskLevelDescriptions = (): IRiskLevelDescription[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(riskLevelDescriptionsSelector);
  const isLoading = useSelector(riskLevelDescriptionsIsLoadingSelector);
  const isReady = useSelector(riskLevelDescriptionsIsReadySelector);
  const error = useSelector(riskLevelDescriptionsErrorSelector);

  const handleFetch = useCallback(() => {
    dispatch(handleGetRiskLevelDescriptions());
  }, [dispatch]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.riskLevelDescriptionsError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useRiskLevelDescriptions);
